import { loadNg1Module, ngmodule } from '../../bootstrap/ngmodule';
import { documentationState } from './documentation.states';
import { documentationComponent } from './documentation.component';

const documentationAppModule: aboTheme.INgModule = {
    components: { documentationComponent },
    states: [ documentationState ],
};

loadNg1Module(ngmodule, documentationAppModule);


// WEBPACK FOOTER //
// ./src/app/modules/documentation/index.ts